const onlyDigits = (v) => (v || "").toString().replace(/\D/g, "");

const maskAreaPhone = (phone, suff = false) => {
	if (!phone) return "-";

	const digits = suff ? phone : (phone || "").replace(/\D/g, "").slice(-10);

	if (digits.length < 6) return "******";

	const prefix = digits.slice(0, 5); // 54115
	const suffix = digits.slice(-1); // 9
	const masked = "*".repeat(Math.max(digits.length - 6, 1));

	return `${prefix}${masked}${suffix}`;
};

const maskPhone = (phone) => {
	const digits = onlyDigits(phone);
	if (!digits) return "";
	if (digits.length < 6) return "******";
	const prefix = digits.slice(0, 5);
	const suffix = digits.slice(-1);
	const masked = "*".repeat(Math.max(digits.length - 6, 1));
	return `${prefix}${masked}${suffix}`;
};

const maskWhatsAppId = (waId) => maskPhone(waId);

const displayPhoneForRole = (phone, isSystemAdmin) =>
	isSystemAdmin ? onlyDigits(phone).slice(-10) : maskAreaPhone(phone);

const displayWaIdForRole = (waId, isSystemAdmin) =>
	isSystemAdmin ? onlyDigits(waId) : maskWhatsAppId(waId);

export {
	onlyDigits,
	maskAreaPhone,
	maskPhone,
	maskWhatsAppId,
	displayPhoneForRole,
	displayWaIdForRole,
};
